import { render, staticRenderFns } from "./PappersAuditor.vue?vue&type=template&id=78dc44f5&scoped=true"
import script from "./PappersAuditor.vue?vue&type=script&lang=js"
export * from "./PappersAuditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc44f5",
  null
  
)

export default component.exports